export const routes = {
  home: '/',
  intake: '/intake',
  summary: '/summary',
  submitted: '/submitted/:id',
} as const;
